// =============================================================================
// journey-chain-component.js – Reusable vertical timeline UI component
// =============================================================================

import { escapeHtml } from "./utils.js";
import { renderProgressBar } from "./connection-progress";

/**
 * Renders the vertical timeline (journey chain) HTML.
 * @param {object} chain - The journey chain data
 * @param {object} thresholds - Connection thresholds
 * @returns {string} HTML string
 */
export function renderJourneyChain(chain, thresholds) {
  if (!chain || !chain.steps || chain.steps.length === 0) return "";

  const stepsHtml = chain.steps
    .map((step, index) => {
      let segmentLineHtml = "";
      if (index < chain.steps.length - 1) {
        let lineColor = "var(--muted)";
        if (step.type === "bus") lineColor = "var(--accent)";
        else if (step.type === "train") lineColor = "var(--ok)";
        else if (step.type === "metro") lineColor = "var(--danger)";

        const lineClass = step.type === "walk" ? "timeline-line--dashed" : "";
        segmentLineHtml = `<div class="timeline-line ${lineClass}" style="background-color: ${lineColor};"></div>`;
      }

      let stepDetailHtml = "";
      if (step.type === "wait" && step.connection) {
        stepDetailHtml = `
        <div class="timeline-step-detail">
          ${renderProgressBar(step.connection.waitMin, thresholds)}
        </div>
      `;
      } else if (step.durationMin > 0) {
        stepDetailHtml = `<div class="timeline-step-duration">${step.durationMin} min</div>`;
      }

      const timeDisplay = step.timeHHMM
        ? `<span class="timeline-step-time">${step.timeHHMM}</span>`
        : `<span class="timeline-step-time timeline-step-time--empty">&bull;&bull;:&bull;&bull;</span>`;

      // V1 - Node category styling
      let nodeClass = "";
      if (index === 0) {
        nodeClass = "node-circle-origin";
      } else if (index === chain.steps.length - 1) {
        nodeClass = "node-circle-destination";
      } else if (step.type === "train" || step.type === "metro" || step.type === "wait") {
        nodeClass = "node-circle-interchange";
      }

      return `
      <div class="timeline-step timeline-step--${step.type}">
        <div class="timeline-step-left">
          ${timeDisplay}
        </div>
        <div class="timeline-step-middle">
          <div class="timeline-node-circle ${nodeClass}">${step.icon}</div>
          ${segmentLineHtml}
        </div>
        <div class="timeline-step-right">
          <div class="timeline-step-title">
            <strong class="timeline-step-label">${escapeHtml(step.label)}</strong>
            <span class="timeline-step-location">${escapeHtml(step.location)}</span>
          </div>
          ${stepDetailHtml}
        </div>
      </div>
    `;
    })
    .join("");

  return `
    <div class="journey-timeline-box">
      <h4>Percorso stimato &middot; ${chain.totalMinutes} min totali</h4>
      <div class="journey-timeline">
        ${stepsHtml}
      </div>
    </div>
  `;
}
